import useSmsCreditAccess from "@/modules/smsCredit/useSmsCreditAccess";
import useGetWallet from "@/pages/dashboard/home/hooks/useGetWalletInfo";
import { Modal, Group, Skeleton, Text, ThemeIcon, UnstyledButton } from "@mantine/core";
import { IconMessage } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import useIsSmall from "@/hooks/useIsSmall";
import SmsCredit from ".";
import IncreaseWallet from "@/modules/home/increaseWallet";
function SmsBalanceLinkContent() {
  const isSmall = useIsSmall();
  const navigate = useNavigate();
  const [opened, setOpened] = useState(false);
  const [recharging, setRecharging] = useState(false);
  const close = () => { setOpened(false); setRecharging(false); };
  const { data, isLoading, isError } = useGetWallet();
  const balance = typeof data?.amount === "number" ? data.amount.toLocaleString("fa-IR") : "—";
  return <><UnstyledButton onClick={() => isSmall ? navigate("/dashboard/sms-credit") : setOpened(true)} aria-label="مشاهده مانده و افزایش شارژ پیامکی" style={{ borderRadius: 20, background: "var(--mantine-color-violet-0)", padding: "6px 10px", minHeight: 44 }}>
    <Group gap={6} wrap="nowrap"><ThemeIcon variant="transparent" color="violet" size="sm"><IconMessage size={19} /></ThemeIcon>{isLoading ? <Skeleton width={65} height={16} /> : <Text size="xs" fw={700} c="violet.9" style={{ whiteSpace: "nowrap" }}>{isError ? "شارژ پیامکی" : balance + " ریال"}</Text>}</Group>
  </UnstyledButton>
    <Modal opened={opened} onClose={close} title={recharging ? "افزایش شارژ پیامکی" : "شارژ پیامکی"} centered size="md" radius="lg">
      {opened && (recharging ? <IncreaseWallet /> : <SmsCredit compact onRecharge={() => setRecharging(true)} />)}
    </Modal>
  </>;
}

export default function SmsBalanceLink() { const { allowed } = useSmsCreditAccess(); return allowed ? <SmsBalanceLinkContent /> : null; }
